// removed by extract-text-webpack-plugin
module.exports = {"coeBackground":"src-components-TeamNew-FollowUsSection----styles-module---coeBackground---XLG6i","divider":"src-components-TeamNew-FollowUsSection----styles-module---divider---36_tG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TeamNew/FollowUsSection/styles.module.scss
// module id = 1871
// module chunks = 165990460456080